const dummyUsers = [
  {
    username: 'e6429264-a051-7038-ccb5-aa02b1c15362',
    email: 'jian.jhn@gmail.com',
    name: 'Jina Thottam',
    phone: '+447576091514',
    enabled: true,
    status: 'CONFIRMED',
    created: '2025-05-17T10:12:55.380Z',
    groups: [
      {
        name: 'User',
        created: '2025-04-14T16:25:53.261Z',
        modified: '2025-04-14T16:25:53.261Z',
      },
    ],
  },
  {
    username: '66a242e4-4021-70b1-28b2-376636391fd4',
    email: 'tessa.kiran@gmail.com',
    name: 'Tessa Kiran',
    phone: '+447576091514',
    enabled: true,
    status: 'CONFIRMED',
    created: '2025-05-17T10:13:56.718Z',
    groups: [
      {
        name: 'User',
        created: '2025-04-14T16:25:53.261Z',
        modified: '2025-04-14T16:25:53.261Z',
      },
    ],
  },
  {
    username: 'f612b2c4-90c1-704b-c6df-3fe176627c40',
    email: 'saneshmat@gmail.com',
    name: 'Sanesh Baby',
    phone: '+447576091514',
    enabled: true,
    status: 'CONFIRMED',
    created: '2025-04-14T21:54:22.264Z',
    groups: [
      {
        name: 'Admin',
        created: '2025-04-14T16:25:48.583Z',
        modified: '2025-04-14T16:25:48.583Z',
      },
    ],
  },
  {
    username: '968272b4-a0c1-701f-4bc6-9feb8a3e00c8',
    email: 'kiranjoshy123@gmail.com',
    name: 'Kiran Joshy',
    phone: '+447880775205',
    enabled: true,
    status: 'CONFIRMED',
    created: '2025-04-14T21:52:53.698Z',
    groups: [
      {
        name: 'Admin',
        created: '2025-04-14T16:25:48.583Z',
        modified: '2025-04-14T16:25:48.583Z',
      },
    ],
  },
  {
    username: 'f68292d4-3001-7099-a902-73897b997f65',
    email: 'kevin.kiran@gmail.com',
    name: 'Kevin Kiran',
    phone: '+447576091514',
    enabled: true,
    status: 'CONFIRMED',
    created: '2025-04-17T10:14:08.126Z',
    groups: [
      {
        name: 'User',
        created: '2025-04-14T16:25:53.261Z',
        modified: '2025-04-14T16:25:53.261Z',
      },
    ],
  },
];

export default dummyUsers;
